import React from "react";
import { Tooltip } from "@sscs/ui";
import { USER_REMOVED } from "Constants";
import styles from "./userAvatar.module.scss";

type UserInfo = {
  first_name: string;
  last_name: string;
  email: string;
};

type UserAvatarProps = {
  user: UserInfo | null | undefined;
  /** Glyph-scale diameter: `md` (24px) everywhere, `lg` (32px) for a two-line cell. */
  size?: "md" | "lg";
  unknownUserMessage?: string;
  showTooltip?: boolean;
};

const UserAvatar = ({
  user,
  size = "md",
  unknownUserMessage = USER_REMOVED,
  showTooltip = true,
}: UserAvatarProps): React.JSX.Element => {
  return (
    <Tooltip
      trigger="graphic"
      disabled={!showTooltip}
      title={
        user
          ? `${user?.first_name} ${user.last_name} (${user.email})`
          : unknownUserMessage
      }
    >
      <div className={`${styles.avatar} ${styles[`size-${size}`]}`}>
        <span className={styles.initials}>
          {user?.first_name[0] ?? "-"}
          {user?.last_name[0] ?? "-"}
        </span>
      </div>
    </Tooltip>
  );
};

export default UserAvatar;
